module.exports = {
  MPA_TRANSACTIONS_CREATE_REQUEST: 'MPA_TRANSACTIONS_CREATE_REQUEST',
  MPA_TRANSACTIONS_CREATE_SUCCESS: 'MPA_TRANSACTIONS_CREATE_SUCCESS',
  MPA_TRANSACTIONS_CREATE_FAILURE: 'MPA_TRANSACTIONS_CREATE_FAILURE',
};
